
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browser-bookmark",
      function () {
        return require("private-next-pages/browser-bookmark/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browser-bookmark"])
      });
    }
  